<template>
  <div class="product-address" v-if="product && (product.needVerifyAddress && !product.monthSend)">
    <div class="address-input" @click="changAddress">
      <div class="addr-text" :class="{empty: !product._address}">{{ product._address ? product._address :'请选择配送区域' }}</div>
      <div class="right">
        <div class="arrow"></div>
      </div>

      <div v-if="product.unavailable" class="unavailable">
        当前位置不支持配送，请选择地址
      </div>
      <div v-else-if="product._address" class="available">
        支持配送
      </div>
    </div>
   
  </div>
</template>

<script>
import api from '../api'
export default {
  props: ['product'],

  methods: {
    changAddress: function(e) {
      this.$selectArea()
      .then((data) => {
        if (data === null) {
          return Promise.resolve(null)
        }
        this.product._address = `${data.province.name} ${data.city.name} ${data.district.name}`
        return api.isDistribution(this.product.id, data.district.id)
      })
      .then((data) => {
        if (data !== null) {
          this.product.unavailable = !data.data
        }
      })
    },
  }
}
</script>

<style lang="stylus">

</style>





// WEBPACK FOOTER //
// select-address.vue?62858162